import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import styled from 'styled-components';
var Context = React.createContext({
  appElement: null,
  isMounting: false
});
var Container = styled.div.withConfig({
  displayName: "AppElement__Container",
  componentId: "sc-1ohexe7-0"
})(["\n  .ReactModal__Body--blur &[aria-hidden] {\n    filter: blur(10px);\n  }\n"]);
/**
 * A root element to wrap your app in. Renders a `<div>` and passes along all
 * props, so you can provide `id="app"` or any other props. This component will
 * save the node it renders and make it available via `context`. This allows
 * components like `Modal` to automatically populate the `appElement` prop if
 * none is provided.
 *
 * Components should use `AppElement.Consumer` to retrieve the `appElement`
 * value. This component follows React's [new Context API](https://github.com/reactjs/rfcs/blob/master/text/0002-new-version-of-context.md).
 */

var AppElement =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(AppElement, _React$Component);

  function AppElement() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      appElement: null,
      isMounting: true
    });

    _defineProperty(_assertThisInitialized(_this), "updateNode", function (node) {
      _this.setState({
        appElement: node,
        isMounting: false
      });
    });

    return _this;
  }

  var _proto = AppElement.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

    return React.createElement(Container, _extends({}, props, {
      ref: this.updateNode
    }), React.createElement(Context.Provider, {
      value: this.state
    }, children));
  };

  return AppElement;
}(React.Component);

_defineProperty(AppElement, "Consumer", Context.Consumer);

export { AppElement as default };